module.exports = __webpack_public_path__ + "static/media/image2.42d0d8f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ClickImage/images/image2.jpg
// module id = 36
// module chunks = 0